import { gql } from "lib/apolloClient";
import { pypElementRatingFragment } from "modules/CommonFragments";

export const PlannerCreateIBPYPElementRatingsMutation = gql`
  mutation PlannerCreateIBPYPElementRatings(
    $input: [IBPYPElementRatingInput!]
  ) {
    planner {
      createIBPYPElementRatings(input: $input) {
        ...basicIBPYPElementRatingItem
      }
    }
  }
  ${pypElementRatingFragment.basicIBPYPElementRating}
`;

export const PlannerDeleteIBPYPElementRatingMutation = gql`
  mutation deleteMultipleIBPYPElementRatings(
    $input: [DeleteIBPYPElementRatingsInput!]
  ) {
    planner {
      deleteMultipleIBPYPElementRatings(input: $input)
    }
  }
`;

export const copyAssessmentDataForStudentsInProjectMutation = gql`
  mutation copyAssessmentDataForStudentsInProject(
    $input: CopyAssessmentDataForStudentsInProjectInput!
  ) {
    documentation {
      copyAssessmentDataForStudentsInProject(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const updateElementRemarkMutationMutation = gql`
  mutation updateElementRemarkMutation($input: [IBPYPElementRemarkInput!]) {
    planner {
      createElementRemarks(input: $input) {
        warning
        response {
          id
          message
          ibPYPElementType
          ibPYPElementId
        }
      }
    }
  }
`;

export const deleteProjectRatingsByIdsMutation = gql`
  mutation deleteProjectRatingsByIds($ids: [ID!]!) {
    planner {
      deleteIBPYPElementRatingByIds(ids: $ids)
    }
  }
`;
